import { MijnRoute } from '../../mijn-navigatie.model';

export const SELF_SERVICE_IDEAL_MAKE_PROFILE: MijnRoute = {
    path: 'profiel-aanmaken',
    navigationEvent: 'toIdealZelfserviceProfielAanmaken',
    regex: /^\/zelf-regelen\/ideal\/profiel-aanmaken$/,
    webcomponent: 'mijn-ideal-zelfservice-webcomponent',
    internalPath: '/profiel-aanmaken'
};
